var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Home",
    "data-name": "Icon - Home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Square",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_-_Home-2",
    "data-name": "Icon - Home",
    d: "M2109.765-2473.588l-14.873-11.515a1.1,1.1,0,0,0-.753-.236,1.107,1.107,0,0,0-.755.236l-14.873,11.515c-1.084.839.436,2.339,1.508,1.508l1.411-1.092c-.043,4.523-.062,9.046-.109,13.569a1.013,1.013,0,0,0,.161.577.892.892,0,0,0,.906.489c2.922-.182,5.851-.113,8.775-.25a1.11,1.11,0,0,0,.343-.073.871.871,0,0,0,.723-.993c-.273-3-.421-6.02-.413-9.033,1.542-.06,3.1-.093,4.644-.021.01,3.02-.139,6.049-.412,9.054a.87.87,0,0,0,.719.992,1.118,1.118,0,0,0,.347.074c2.924.136,5.853.068,8.775.25a.893.893,0,0,0,.9-.482,1.011,1.011,0,0,0,.165-.584c-.048-4.523-.066-9.047-.109-13.569l1.411,1.092C2109.33-2471.25,2110.85-2472.749,2109.765-2473.588Zm-4.951,12.863c-2.183-.095-4.368-.082-6.552-.15.246-3,.378-6.023.331-9.032a.982.982,0,0,0-.6-.926,1.117,1.117,0,0,0-.465-.141,54.2,54.2,0,0,0-6.777,0,1.06,1.06,0,0,0-.557.181h0c-.026.018-.053.034-.077.054a.983.983,0,0,0-.43.831c-.047,3.009.085,6.031.331,9.032-2.184.067-4.369.055-6.552.15.044-4.559.062-9.119.111-13.678a1.1,1.1,0,0,0-.064-.378l10.629-8.23,10.63,8.23a1.067,1.067,0,0,0-.064.378C2104.752-2469.844,2104.771-2465.285,2104.814-2460.726Z",
    transform: "translate(-2078.138 2488.342)",
    fill: "#f990c2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/Icon-Home.e2029e917676b20a290bf0a2d160e467.svg";
export { ForwardRef as ReactComponent };